<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    :search-input.sync="search"
    :label="label"
    :rules="[v => !!v || '']"
    :disabled="readonly"
    height="44"
    return-object
    hide-details
    browser-autocomplete="nope"
    no-filter
    no-data-text="У производеля не указанны места погрузки"
    outline
    @change="handleItemChange"
  >
    <template v-slot:prepend-item>
      <slot name="prepend-content">
        <v-layout>
          <v-spacer />
          <v-btn
            small
            right
            @click="createNew"
          >
            Добавить
          </v-btn>
        </v-layout>
      </slot>
    </template>
  </v-autocomplete>
</template>

<script>
import { NestedEditorsEventBus } from "../../../components/nested-editors/nested-editors-event-bus.js";
import * as routesApi from "../../../backend/routesApi.js";

export default {
  props: ["entity", "factoryId", "label"],
  data() {
    return {
      selected: null,
      search: null,
      items: [],
      resource: "loading-places",
      componentName: "LoadingPlaceModal",
    };
  },
  computed: {
    readonly() {
      return this.factoryId ? false : true;
    },
  },
  watch: {
    value(val) {
      this.selected = {
        text: val.title,
        value: val.id,
      };
    },
    factoryId: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    selected(newValue) {
      if (newValue) {
        this.entity.unloadingAddress = {
          id: newValue.value,
          title: newValue.text,
        };
      } else {
        this.entity.unloadingAddress = null;
      }
    },
    search() {
      if (!this.search) {
        this.selected = null;
        this.getData();
        return;
      } else {
        if (this.selected && this.selected.text === this.search) {
          return;
        }

        setTimeout(() => {
          if (!this.search) {
            this.selected = null;
            this.items = [];
            return;
          }
          this.searchLoadingPlace();
        }, 500);
      }
    },
  },
  created() {
    NestedEditorsEventBus.$on("create-" + this._uid, (createdId) => {
      this.getFactoryLoadingPlaceReference(createdId);
    });
    this.getData();
  },
  methods: {
    handleItemChange() {
      this.$emit(
        "input",
        this.selected
          ? { id: this.selected.value, title: this.selected.text }
          : null,
      );
    },
    async getData() {
      if (!this.factoryId) {
        this.selected = null;
        this.search = null;
        this.items = [];
        return;
      }

      const loadingPlaces = await routesApi.getLoadingPlaceReference(
        this.factoryId,
      );
      if (loadingPlaces.length) {
        this.items = loadingPlaces.filter(
          (i) => i.countryId === this.entity.unloadingCountry.id,
        );
        this.selected = this.items[0];
        this.entity.unloadingAddress = {
          id: this.items[0].value,
          title: this.items[0].text,
        };
      }
    },
    createNew() {
      const vMenu = this.$children[0].$children.find(
        (c) => c.$options.name === "v-menu",
      );
      if (vMenu) {
        vMenu.$data.isActive = false;
      }
      this.$emit("click");
      NestedEditorsEventBus.$emit("open", {
        title: this.label,
        uid: this._uid,
        component: this.componentName,
        params: { factoryId: this.factoryId },
      });
    },
    setSelectedElement(value) {
      const newItem = {
        value: value.id,
        text: value.title,
      };
      this.items.push(newItem);
      this.selected = newItem;
      this.entity.unloadingAddress = {
        id: newItem.value,
        title: newItem.text,
      };
    },
    async getFactoryLoadingPlaceReference(createdId) {
      const res = await routesApi.getFactoryLoadingPlaceReference(
        this.factoryId,
        createdId,
      );
      this.setSelectedElement(res);
      this.$emit("input");
    },
    async searchLoadingPlace() {
      this.items = await routesApi.searchLoadingPlace(
        this.factoryId,
        this.search,
      );
    },
  },
};
</script>
